import { render, staticRenderFns } from "./RutasDetalles.vue?vue&type=template&id=3a85344e"
import script from "./RutasDetalles.vue?vue&type=script&lang=js"
export * from "./RutasDetalles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports